"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
exports.default = vue_1.default.extend({
    data() {
        return {
            borderImageUrl: 'url(images/game/common/img_dialog_frame.png)',
        };
    },
    methods: {
        closeModal() {
            this.$store.commit('showComponent', {
                component: 'systemRequirementModal',
                isShow: false,
            });
        },
    },
    mounted() {
        // Make border of content responsive
        const contentWidth = this.$refs.content.clientWidth;
        this.$refs.content.style.borderWidth = `${contentWidth * 0.012}px`;
    },
});
